export default __webpack_public_path__ + "images/VA.bec09d6.png";